import type { ComponentType } from "react"
import { createRoot } from "react-dom/client"
import { createInertiaApp } from "@inertiajs/react"
import "../styles/application.css"

const pages = import.meta.glob("../pages/**/*.tsx", { eager: true })

function normalizePagePath(path: string) {
  return path
    .replace(/^\.\.\/pages\//, "")
    .replace(/\.tsx$/, "")
    .split("/")
    .map((part) => part.toLowerCase())
    .join("/")
}

createInertiaApp({
  resolve: async (name) => {
    const normalizedName = name.split("/").map((part) => part.toLowerCase()).join("/")
    const page = Object.entries(pages).find(([path]) => normalizePagePath(path) === normalizedName)?.[1] as
      | { default: ComponentType<any> }
      | undefined

    if (!page) {
      throw new Error(`Missing page component: ${name}`)
    }

    return page.default
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
